import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router';
export const SettingsIconLink = () => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="focus:ring-indigo-500 rounded-full p-1 text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2"
      data-testid="settings-icon-link"
      aria-label="Settings"
      onClick={() => {
        navigate('/settings');
      }}
    >
      <span className="sr-only">Settings</span>
      <Cog6ToothIcon className="h-7 w-7" aria-hidden="true" />
    </button>
  );
};
